import React from 'react';
import { Box } from '@mui/material';
import { getStepPath } from '../utils';

interface SVGStepRendererProps {
  propertyType: string;
  currentStep: number;
  isComplete: boolean;
  navHeight?: number;
}

export const StepRenderer: React.FC<SVGStepRendererProps> = ({
  propertyType,
  currentStep,
  isComplete,
  navHeight = 64,
}) => {
  if (!propertyType) return null;

  const stepToShow = isComplete ? 'DONE' : currentStep;
  const svgPath = getStepPath(propertyType, stepToShow);

  return (
    <Box
      sx={{
        position: 'fixed',
        right: 0,
        bottom: '25%',
        transform: 'translateY(50%)',
        width: '500px',
        height: 'auto',
        display: 'none',
        alignItems: 'flex-end',
        justifyContent: 'center',
        opacity: 0.8,
        transition:
          'opacity 0.3s ease-in-out, bottom 0.3s ease-in-out, width 0.3s ease-in-out',
        pointerEvents: 'none',
        zIndex: 0,
        pr: 3,
        '& img': {
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
        },
        // Show above 1450px
        '@media (min-width: 1450px)': {
          display: 'flex',
          width: '250px',
          bottom: '25%',
          transform: 'translateY(50%)',
        },
        // Above 1920px: center vertically with larger width
        '@media (min-width: 1800px)': {
          width: '250px',
          bottom: '50%',
          right: '5%',
          transform: 'translateY(50%)',
          paddingTop: `${navHeight}px`,
        },
        // Above 2400px: 50% width
        '@media (min-width: 2300px)': {
          width: '15%',
          maxWidth: '1200px',
          right: '25%',
          bottom: '50%',
          transform: 'translateY(50%)',
          paddingTop: `${navHeight}px`,
        },
      }}
    >
      <img
        src={svgPath}
        alt={`Property progress step ${stepToShow}`}
        loading="lazy"
      />
    </Box>
  );
};
